import { AnalyticsUnitReq, MontlyMisInfoReq, ProductReq, StockInResponseData } from "@gtpl/shared-models/analytics-data";
import { ContainerWiseAbstractReq, ContainerWiseAbstractResponseModel, DaywiseAnalysisResponseModel, DayWiseProductionReq, DaywiseProductionResponseModel, ExpectedStockInOutResponse, JobIdRequest, LotWiseInfoResponseModel, MonthWiseShrimpReq, ProductAnalysisReq, ProductAnalysisResponseModel, ProductSummaryReportReq, StockInRqstDto, StockSTatementReq, StockStatementResponseModel, StockValuationResponseModel } from "@gtpl/shared-models/warehouse-management";
import { Body } from "@nestjs/common";
import axios from "axios";
import { CommonResponse } from "../../../../shared-models/sale-management/src";
import connection from "./connection";
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import { DateFilter, UnitRequest } from "@gtpl/shared-models/common-models";
import { LotCodeDropDown } from "@gtpl/shared-models/production-management";

export class WarehouseDashboardService {
    URL = connection.DEPLOY_URL + '/warehouse';

    async getStockInfo(req: StockInRqstDto): Promise<StockInResponseData> {
        return await axios.post(this.URL + '/getStockInfo', req)
            .then(res => {
                return res.data
            })
    }
    async getrecentFiveStockIns(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getrecentFiveStockIns',req)
            .then(res => {
                return res.data
            })
    }
    async getrecentFiveStockOuts(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getrecentFiveStockOuts',req)
            .then(res => {
                return res.data
            })
    }
    async getTodaysStockOutSOs(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTodaysStockOutSOs',req)
            .then(res => {
                return res.data
            })
    }
    async getTodayStockTransfers(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTodayStockTransfers',req)
            .then(res => {
                return res.data
            })
    }
    async getCartonsInWayRacks(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCartonsInWayRacks',req)
            .then(res => {
                return res.data
            })
    }
    async getWarehouseCapacity(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getWarehouseCapacity',req)
            .then(res => {
                return res.data
            })
    }
    async getLongRunningDummyStock(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLongRunningDummyStock',req)
            .then(res => {
                return res.data
            })
    }
    async getRepackingEfficiency(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRepackingEfficiency',req)
            .then(res => {
                return res.data
            })
    }
    async getExpectedStockInsAndStockOuts(req:AnalyticsUnitReq): Promise<ExpectedStockInOutResponse> {
        return await axios.post(this.URL + '/getExpectedStockInsAndStockOuts',req)
            .then(res => {
                return res.data
            })
    }
    async getPOsProductionAbove70Perc(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPOsProductionAbove70Perc',req)
            .then(res => {
                return res.data
            })
    }

    async getTransferdSOsStock(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTransferdSOsStock',req)
            .then(res => {
                return res.data
            })
    }
    async getWarehouseLifeCycle(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getWarehouseLifeCycle',req)
            .then(res => {
                return res.data
            })
    }
    async getTop10DummyProducts(req:AnalyticsUnitReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTop10DummyProducts',req)
            .then(res => {
                return res.data
            })
    }

    async getStockValuationReport(req:ProductReq): Promise<StockValuationResponseModel> {
        return await axios.post(this.URL + '/getStockValuationReport',req)
            .then(res => {
                return res.data
            })
    }

    async getVarientCodeDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVarientCodeDropdown')
            .then(res => {
                return res.data
            })
    }

    async getStockStatementInfo(req:StockSTatementReq): Promise<StockStatementResponseModel> {
        return await axios.post(this.URL + '/getStockStatementInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getProductionAnalysisInfo(req:ProductAnalysisReq): Promise<ProductAnalysisResponseModel> {
        return await axios.post(this.URL + '/getProductionAnalysisInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getDayWiseProdcutionReport(req : DayWiseProductionReq): Promise<DaywiseProductionResponseModel> {
        return await axios.post(this.URL + '/getDayWiseProdcutionReport',req)
            .then(res => {
                return res.data
            })
    }

    async getTodayStockInInfo(req:UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTodayStockInInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getReportedQtyAgainstJob(req:JobIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReportedQtyAgainstJob',req)
            .then(res => {
                return res.data
            })
    }

    async getContainerWiseAbstract(req:ContainerWiseAbstractReq): Promise<ContainerWiseAbstractResponseModel> {
        return await axios.post(this.URL + '/getContainerWiseAbstract',req)
            .then(res => {
                return res.data
            })
    }

    async getDayWiseAnalysisReport(req : DayWiseProductionReq): Promise<DaywiseAnalysisResponseModel> {
        return await axios.post(this.URL + '/getDayWiseAnalysisReport',req)
            .then(res => {
                return res.data
            })
    }

    
    async getMonthlyShrimpMISReport(req:MonthWiseShrimpReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getMonthlyShrimpMISReport',req)
            .then(res => {
                return res.data
            })
    }

    async getShippedContainerMISDetails(req:MonthWiseShrimpReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getShippedContainerMISDetails',req)
            .then(res => {
                return res.data
            })
    }

    async getGrnQuantityForMISReport(req:MonthWiseShrimpReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getGrnQuantityForMISReport',req)
            .then(res => {
                return res.data
            })
    }

    async getMISproductDetailedReport(req:ProductAnalysisReq): Promise<ProductAnalysisResponseModel> {
        return await axios.post(this.URL + '/getMISproductDetailedReport',req)
            .then(res => {
                return res.data
            })
    }

    async getGradesOpeningStockForProductionReport(req:ProductSummaryReportReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getGradesOpeningStockForProductionReport',req)
            .then(res => {
                return res.data
            })
    }

    async getProductionGradeInfoForProductionReport(req:ProductSummaryReportReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductionGradeInfoForProductionReport',req)
            .then(res => {
                return res.data
            })
    }

    async getShippedReprocessedGradeInfoForProductionReport(req:ProductSummaryReportReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getShippedReprocessedGradeInfoForProductionReport',req)
            .then(res => {
                return res.data
            })
    }

    async getShortCodeDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getShortCodeDropdown')
            .then(res => {
                return res.data
            })
    }

    async getPackStyleForProductAnalysisReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPackStyleForProductAnalysisReport')
        .then(res => {
            return res.data
        })
    }
    
    async updateProductionCostAnalysis(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateProductionCostAnalysis')
            .then(res => {
                return res.data
            })
    }

    async getMontlyMisInfo(req:MontlyMisInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getMontlyMisInfo',req)
            .then(res => {
                return res.data
            })
    }
    async updateRmPurchaseAnalysis(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateRmPurchaseAnalysis')
            .then(res => {
                return res.data
            })
    }

    async dayWiseProductionReport(req:DayWiseProductionReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/dayWiseProductionReport',req)
            .then(res => {
                return res.data
            })
    }

    async getAllLotNumbersDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllLotNumbersDropdown')
            .then(res => {
                return res.data
            })
    }

    async getLotWiseReportInfo(req:DateFilter): Promise<LotWiseInfoResponseModel> {
        return await axios.post(this.URL + '/getLotWiseReportInfo',req)
            .then(res => {
                return res.data
            })
    }

    async updateDaywiseOpeningStockInfo(): Promise<LotWiseInfoResponseModel> {
        return await axios.post(this.URL + '/updateDaywiseOpeningStockInfo')
            .then(res => {
                return res.data
            })
    }

}